import React, { useState, useCallback } from "react";
import {
    Box,
    Button,
    Grid,
    InputLabel,
    TextField,
    FormControl,
    Select,
    MenuItem,
    Typography,
    IconButton,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import api from "../../../services/QualityAssurance";
import { useGetClassAndSubjectTeacherQuery, useGetLessonSubjectQuery } from "../../../api/lessonNoteApi";
import { useParams } from "react-router-dom";

const AddBook = ({ onSuccess }) => {
    const { admToken, user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const { data: lessonSubject = [], isLoading: subjectLoading } = useGetLessonSubjectQuery();
    const { data: classAndArm, isLoading } = useGetClassAndSubjectTeacherQuery(user ? user.schoolId : 0);
    const [coverFiles, setCoverFiles] = useState({
        coverPage: null,
        coverImage: null,
    });
    const [coverPreviews, setCoverPreviews] = useState({
        coverPage: "",
        coverImage: "",
    });


    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        vendorId: id,
        bookTitle: '',
        bookAuthor: '',
        isbn: '',
        publisher: '',
        placeOfPublication: '',
        editor: '',
        edition: '',
        copyWriteDate: '',
        category: '',
        coverType: '',
        cost: 0,
        subject: '',
        class: '',
        copies: 0,
        coverPage: '',
        bookId: 0,
        coverPageImageFile: null
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;

        setCoverFiles((prev) => ({
            ...prev,
            [type]: file,
        }));

        if (file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = (ev) => {
                setCoverPreviews((prev) => ({
                    ...prev,
                    [type]: ev.target.result,
                }));
            };
            reader.readAsDataURL(file);
        } else {
            setCoverPreviews((prev) => ({
                ...prev,
                [type]: file.name,
            }));
        }
    };

    const removeFile = (type) => {
        setCoverFiles((prev) => ({ ...prev, [type]: null }));
        setCoverPreviews((prev) => ({ ...prev, [type]: "" }));
    };


    const handleSubmit = useCallback(async () => {
        if (!formData.vendorId) return;

        try {
            setLoading(true);
            const form = new FormData();
            form.append("VendorId", Number(formData.vendorId));
            form.append("BookTitle", formData.bookTitle);
            form.append("BookAuthor", formData.bookAuthor);
            form.append("ISBN", formData.isbn);
            form.append("Publisher", formData.publisher);
            form.append("PlaceOfPublication", formData.placeOfPublication);
            form.append("Editor", formData.editor);
            form.append("Edition", formData.edition);
            form.append("CopyWriteDate", formData.copyWriteDate);
            form.append("Category", formData.category);
            form.append("CoverType", formData.coverType);
            form.append("Cost", Number(formData.cost));
            form.append("Subject", formData.subject);
            form.append("Class", formData.class);
            form.append("Copies", Number(formData.copies));
            form.append("BookId", 0);
            form.append("CoverPage", formData.coverPage);

            if (coverFiles.coverImage) form.append("CoverPageImageFile", coverFiles.coverImage);

            const res = await api.createBook(admToken, form);

            if (res?.status && res?.statusCode === 2) {
                toast.success(res.data.message || res.message);
                setFormData({
                    vendorId: 0,
                    bookTitle: '',
                    bookAuthor: '',
                    isbn: '',
                    publisher: '',
                    placeOfPublication: '',
                    editor: '',
                    edition: '',
                    copyWriteDate: '',
                    category: '',
                    coverType: '',
                    cost: 0,
                    subject: '',
                    class: '',
                    copies: 0,
                    coverPage: '',
                    bookId: 0
                });
                removeFile();
                if (onSuccess) onSuccess();
            } else {
                toast.error(res.data.message || res.message);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [admToken, removeFile, formData, onSuccess]);


    return (
        <Box>
            <Typography variant="h6" sx={{ mb: 2, fontFamily: "Gilroy-Medium" }}>
                Add Book
            </Typography>
            <Grid container spacing={2}>
                <Grid item md={12} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Book Tittle</InputLabel>
                    <TextField
                        name="bookTitle"
                        fullWidth
                        size="small"
                        value={formData.bookTitle}
                        onChange={handleChange}
                        sx={{
                            "& .MuiOutlinedInput-root": { "& fieldset": { border: "1px solid #671E78" } },
                        }}
                    />
                </Grid>

                <Grid item md={12} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Author</InputLabel>
                    <TextField name="bookAuthor" fullWidth size="small" value={formData.bookAuthor} onChange={handleChange} />
                </Grid>

                <Grid item md={6} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>ISBN</InputLabel>
                    <TextField name="isbn" fullWidth size="small" value={formData.isbn} onChange={handleChange} />
                </Grid>
                <Grid item md={6} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Publisher</InputLabel>
                    <TextField name="publisher" fullWidth size="small" value={formData.publisher} onChange={handleChange} />
                </Grid>

                <Grid item md={12} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Place of Publication</InputLabel>
                    <TextField name="placeOfPublication" fullWidth size="small" value={formData.placeOfPublication} onChange={handleChange} />
                </Grid>

                <Grid item md={6} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Editor</InputLabel>
                    <TextField name="editor" fullWidth size="small" value={formData.editor} onChange={handleChange} />
                </Grid>
                <Grid item md={6} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Edition</InputLabel>
                    <TextField name="edition" fullWidth size="small" value={formData.edition} onChange={handleChange} />
                </Grid>

                <Grid item md={6} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Copywrite Date</InputLabel>
                    <TextField name="copyWriteDate" fullWidth size="small" value={formData.copyWriteDate} onChange={handleChange} />
                </Grid>
                <Grid item md={6} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Category</InputLabel>
                    <TextField name="category" fullWidth size="small" value={formData.category} onChange={handleChange} />
                </Grid>

                <Grid item md={6} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Cover Type</InputLabel>
                    <FormControl fullWidth size="small">
                        <Select name="coverType" value={formData.coverType} onChange={handleChange}>
                            <MenuItem value="Hardcover">Hardcover</MenuItem>
                            <MenuItem value="Paperback">Paperback</MenuItem>
                            <MenuItem value="Spiral">Spiral</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item md={6} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Cost</InputLabel>
                    <TextField name="cost" fullWidth size="small" value={formData.cost} onChange={handleChange} />
                </Grid>

                <Grid item md={6} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Subject</InputLabel>
                    <FormControl fullWidth>
                        <Select
                            name="subject"
                            sx={{ fontFamily: "Gilroy-Regular" }}
                            variant="outlined"
                            size="small"
                            value={formData.subject}
                            onChange={handleChange}
                            disabled={subjectLoading}
                        >
                            {subjectLoading ? (
                                <MenuItem disabled>Loading subjects...</MenuItem>
                            ) : lessonSubject.length === 0 ? (
                                <MenuItem disabled>No subjects available</MenuItem>
                            ) : (
                                lessonSubject.map((item) => (
                                    <MenuItem
                                        sx={{ fontFamily: "Gilroy-Regular" }}
                                        value={item.name}
                                        key={item.id}
                                    >
                                        {item.name}
                                    </MenuItem>
                                ))
                            )}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item md={6} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Class</InputLabel>
                    <FormControl fullWidth>
                        <Select
                            name="class"
                            sx={{
                                fontFamily: "Gilroy-Regular",
                                border: "0.5px solid #fff",
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        border: "1px solid #fff",
                                    },
                                },
                            }}
                            variant="outlined"
                            size="small"
                            value={formData.class}
                            onChange={handleChange}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <MenuItem disabled>Loading class...</MenuItem>
                            ) : !classAndArm?.data || classAndArm.data.length === 0 ? (
                                <MenuItem disabled>No session available</MenuItem>
                            ) : (
                                classAndArm.data.map((item) => (
                                    <MenuItem
                                        sx={{ fontFamily: "Gilroy-Regular" }}
                                        value={item.className}
                                        key={item.classId}
                                    >
                                        {item.className} {item.classArm}
                                    </MenuItem>
                                ))
                            )}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item md={12} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Copies</InputLabel>
                    <TextField name="copies" fullWidth size="small" value={formData.copies} onChange={handleChange} />
                </Grid>

                <Grid item md={12} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Cover Page</InputLabel>
                     <TextField name="coverPage" fullWidth size="small" value={formData.coverPage} onChange={handleChange} />
                </Grid>

                <Grid item md={12} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Cover Page Image File</InputLabel>
                    <Box>
                        <Button variant="outlined" component="label" sx={{ borderColor: "#671e78" }}>
                            Choose Cover Image
                            <input hidden accept="image/*" type="file" onChange={(e) => handleFileChange(e, "coverImage")} />
                        </Button>

                        {coverPreviews.coverImage && (
                            <Box sx={{ position: "relative", mt: 2 }}>
                                <img src={coverPreviews.coverImage} alt="Cover Image Preview" style={{ maxHeight: 80, objectFit: "cover" }} />
                                <IconButton onClick={() => removeFile("coverImage")} sx={{ position: "absolute", top: -8, right: -8, bgcolor: "#fff" }}>
                                    <HighlightOffIcon sx={{ color: "#e53935" }} />
                                </IconButton>
                            </Box>
                        )}
                    </Box>
                </Grid>

                <Grid item md={12} xs={12}>
                    <Box mt={2}>
                        <Button variant="contained" fullWidth sx={{ background: "#671e78", textTransform: "initial" }} onClick={handleSubmit} disabled={loading}>
                            {loading ? "Adding..." : "Add Book"}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AddBook;
